import React, { useState } from 'react';
import {
  FlexRow,
  Body,
  Heading,
  InformationIcon,
  PopoverContainer,
  Popover,
  Link,
  Col,
  Box,
} from '@edreamsodigeo/prisma-design-system';
import {
  useTranslation,
  Trans,
  createFeature,
  Desktop,
  Mobile,
} from '@edreamsodigeo/frontend-core';
import { PRIME_FIRST_PHASE_1 } from '@/versionedComponents';
import { useLogin } from '@/providers/login/LoginProvider';

const PrivacyNoticeLink = () => {
  const { t } = useTranslation();
  return (
    <Link
      href={t('variables.privacyPolicy.url')}
      target={'_blank'}
      type={'primary'}
    >
      <Body inline type="xSmall">
        {t('pricefreeze.form.passenger.newinformationlink')}
      </Body>
    </Link>
  );
};

const Info = () => {
  const [open, setOpen] = useState(false);
  return (
    <PopoverContainer onClick={() => setOpen(false)}>
      <Box pt="tiny">
        <InformationIcon
          color="neutral.60"
          size="small"
          onClick={(event) => {
            event.stopPropagation();
            setOpen(!open);
          }}
          aria-label="PaxFormHeaderInformationIcon"
        />
      </Box>
      <Popover open={open} size="small" placement="bottom" align="middle">
        <Body type="xSmall" color="neutral.100">
          <Trans
            i18nKey="pricefreeze.form.passenger.newinformation"
            components={{
              privacyNoticeLink: <PrivacyNoticeLink />,
            }}
          />
        </Body>
      </Popover>
    </PopoverContainer>
  );
};

const RecognizeUserSubtitle = ({ t }) =>
  t('pricefreeze.summaryPage.form.contact.subtitle');

const PrimeAcquisitionSubtitle = ({ t }) => {
  const { isPrime } = useLogin();

  if (isPrime) return <RecognizeUserSubtitle t={t} />;
  return t('pricefreeze.summaryPage.form.contact.primeFirst.subtitle');
};

const VersionedSubtitle = createFeature({
  name: PRIME_FIRST_PHASE_1,
  variations: [RecognizeUserSubtitle, PrimeAcquisitionSubtitle],
  version: 1,
});

export const Header = () => {
  const { t } = useTranslation();
  return (
    <>
      <FlexRow alignItems="start-end" gap={3} mb="1x_small">
        <Col ml="base">
          <FlexRow gap={2}>
            <Col mt="2x_small" mr="1x_small">
              <Heading type="3" weight="medium" color="neutral.100">
                {t('pricefreeze.primefirst.contact.title')}
              </Heading>
            </Col>
            <Col>
              <Info />
            </Col>
          </FlexRow>
        </Col>
      </FlexRow>
      <Box mb="big">
        <Body type="small" color="neutral.90">
          <Desktop>
            <RecognizeUserSubtitle t={t} />
          </Desktop>
          <Mobile>
            <VersionedSubtitle t={t} />
          </Mobile>
        </Body>
      </Box>
    </>
  );
};
